// This file will serve as an example for a patten we will have to follow moving forwards with some API responses.
// It will be necessary to hardcode an entire example of an API "options-like" object response, so that we can key the
// object as we see fit and make changes to it to work better with the front-end.
// This will require coordination between the front and backend changes that implies an anti-pattern awareness of the
// backend by the front end. However, it will be very useful for a few use-cases, notably translations where the API
// contains English strings.

import { EColors } from 'theme';

export type VenueTypesDictAPI = {
    [key: number]: { numId: number; id: BizlyAPI.Venue.Types; label: string; pinColor: EColors };
};

export type VenueTypesAPIDictOptions = {
    showTestingVenues?: boolean;
};

const TESTING_VENUE_TYPE_ENTRY = {
    numId: 110,
    id: 'testing' as const,
    label: 'Testing',
    pinColor: EColors.venuePinTesting,
};

export const venueTypesAPIDict = (options?: VenueTypesAPIDictOptions): VenueTypesDictAPI => {
    const dict: VenueTypesDictAPI = {
        10: {
            // numID 10, or corporate office, is overwritten with the team name on the UI for users
            numId: 10,
            id: 'corporate office',
            label: 'Corporate Office',
            pinColor: EColors.venuePinOffice,
        },
        1: {
            numId: 1,
            id: 'hotel',
            label: 'Hotel',
            pinColor: EColors.venuePinHotel,
        },
        2: {
            numId: 2,
            id: 'restaurant',
            label: 'Restaurant',
            pinColor: EColors.venuePinDining,
        },
        3: {
            numId: 3,
            id: 'activity',
            label: 'Activity',
            pinColor: EColors.venuePinActivityUnique,
        },
        7: {
            numId: 7,
            id: 'conference center',
            label: 'Conference Center',
            pinColor: EColors.venuePinEventMeetingConference,
        },
        20: {
            numId: 20,
            id: 'bar',
            label: 'Bar',
            pinColor: EColors.venuePinDining,
        },
        30: {
            numId: 30,
            id: 'brewery',
            label: 'Brewery',
            pinColor: EColors.venuePinDining,
        },
        40: {
            numId: 40,
            id: 'winery',
            label: 'Winery',
            pinColor: EColors.venuePinDining,
        },
        50: {
            numId: 50,
            id: 'museum',
            label: 'Museum',
            pinColor: EColors.venuePinMuseumTheater,
        },
        60: {
            numId: 60,
            id: 'theater',
            label: 'Theater',
            pinColor: EColors.venuePinMuseumTheater,
        },
        70: {
            numId: 70,
            id: 'unique venue',
            label: 'Unique Venue',
            pinColor: EColors.venuePinActivityUnique,
        },
        80: {
            numId: 80,
            id: 'event venue',
            label: 'Event Venue',
            pinColor: EColors.venuePinEventMeetingConference,
        },
        100: {
            numId: 100,
            id: 'coworking space',
            label: 'Coworking Space',
            pinColor: EColors.venuePinWorkspace,
        },
    };

    if (options?.showTestingVenues) {
        dict[110] = TESTING_VENUE_TYPE_ENTRY;
    }

    return dict;
};
